import BaseCtrl from 'edge/platform/base/BaseCtrl';
import FormUtil from 'edge/platform/modelvalidation/FormUtil';

var fn = function fn($scope, submissionViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVm = submissionViewModel();

    ctrl.init = function () {
        $scope.view = submissionVm.lobData.homeowners.coverables.construction;

        if (!$scope.view.value) {
            $scope.view.value = {
                hasGarage: false, // requirement
                secondaryHeatingExists: true // requirement
            };
        }
    };

    ctrl.isOther = function (val) {
        return val && val.toLowerCase() === 'other';
    };

    ctrl.next = function (nextFn, form) {
        FormUtil.markFormsSubmitted(form);
        nextFn(submissionVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/controllers/HOConstructionCtrl.js
// module id = 2147
// module chunks = 0